<template>
  <v-dialog v-bind:value="value" v-on:input="close" width="400">
    <v-card>
      <v-card-title>Modifica della password</v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="oldPassword.value"
            v-bind:rules="[rules.required]"
            label="Password corrente"
            v-bind:append-icon="oldPassword.visible ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="oldPassword.visible ? 'text' : 'password'"
            v-on:click:append="oldPassword.visible = !oldPassword.visible"
          />
          <v-text-field
            v-model="newPassword.value"
            v-bind:rules="[rules.required]"
            label="Nuova password"
            v-bind:append-icon="newPassword.visible ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="newPassword.visible ? 'text' : 'password'"
            v-on:click:append="newPassword.visible = !newPassword.visible"
          />
          <v-text-field
            ref="confirmPassword"
            v-model="confirmPassword.value"
            v-bind:rules="[rules.required]"
            label="Conferma nuova password"
            v-bind:append-icon="confirmPassword.visible ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="confirmPassword.visible ? 'text' : 'password'"
            v-on:click:append="confirmPassword.visible = !confirmPassword.visible"
            v-bind:error-messages="confirmPassword.errorMessage"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="primary" v-on:click="save">Modifica</v-btn>
        <v-btn class="primary" v-on:click="close">Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'

export default {
  name: 'ChangePassword',

  mixins: [ server, utils ],

  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    rules: {
      required: value => !!value || 'Valore richiesto.',
    },
    valid: true,
    oldPassword: { value: '', visible: false },
    newPassword:  { value: '', visible: false },
    confirmPassword:  { value: '', visible: false, errorMessage: '' },
  }),

  watch: {
    value: { handler (newValue) { newValue && this.$refs.form && this.$refs.form.resetValidation(); } }
  },

  methods: {
    close: function() {
      this.oldPassword.value = '';
      this.oldPassword.visible = false;
      this.newPassword.value = '';
      this.newPassword.visible = false;
      this.confirmPassword.value = '';
      this.confirmPassword.visible = false;
      this.confirmPassword.errorMessage = '';
      this.$emit('input', false);
    },

    save: function() {
      // Validate form first
      if (this.$refs.form.validate()) {
        // Check new and confirm password
        if (this.newPassword.value !== this.confirmPassword.value) {
          this.confirmPassword.errorMessage = 'La password non coincide';
        } else {
          this.confirmPassword.errorMessage = '';
          this.server_save({
            url: 'User/changePassword',
            data: {
              'old_password': this.oldPassword.value,
              'new_password': this.newPassword.value,
            },
            onSuccess: this.close,
          });
        }
      }
    },
  }
}
</script>
